/**
 * SessionStorage key used to prevent redirect from /login (or /register) when
 * the tenant selection modal is showing or about to show. Checked in route beforeLoad.
 */
export const PENDING_TENANT_SELECTION_KEY = 'loginFlow.pendingTenantSelection';

export function getPendingTenantSelectionFlag(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  const v = !!sessionStorage.getItem(PENDING_TENANT_SELECTION_KEY);
  return v;
}

export function setPendingTenantSelectionFlag(): void {
  sessionStorage.setItem(PENDING_TENANT_SELECTION_KEY, '1');
  console.log('[LoginFlow] setPendingTenantSelectionFlag: flag SET');
}

export function clearPendingTenantSelectionFlag(): void {
  sessionStorage.removeItem(PENDING_TENANT_SELECTION_KEY);
  console.log('[LoginFlow] clearPendingTenantSelectionFlag: flag CLEARED');
}
